<script setup lang="ts">
import { computed, ref } from "vue"
import { storeToRefs } from "pinia"
import { useUserStore } from "~/store"

const props = defineProps({
    epciCommuneInput: { type: Object, required: true },
})

const show = defineModel<boolean>("show", { required: true })

const { currentUser } = storeToRefs(useUserStore())
const isActive = ref(false)

const canGenerateInventory = computed(() => {
    return currentUser.value
        && ["admin", "superuser"].includes(currentUser.value.role)
        && props.epciCommuneInput?.inventory
})

const downloadWrapper = ref<HTMLElement | null>(null)
function confirmGeneration() {
    isActive.value = false
    if (downloadWrapper.value) {
        downloadWrapper.value.click()
    }
}

// const formattedLastDate = computed(() => {
//     const dateString = currentEpciCommune?.last_inventory_date
//
//     if (!dateString)
//         return null
//
//     return new Date(dateString).toLocaleDateString("fr-FR", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//     })
// })
</script>

<template>
    <v-dialog v-model="show" max-width="500">
        <v-card
            v-if="epciCommuneInput?.inventory || epciCommuneInput?.download"
            rounded="lg"
            elevation="10"
        >
            <v-card-title class="d-flex align-center border-b px-6 py-4">
                <h2 class="text-h6 font-weight-bold mb-0">
                    Inventaire - {{ epciCommuneInput.name }}
                </h2>
                <v-spacer />
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    size="small"
                    color="grey-darken-1"
                    aria-label="Fermer"
                    @click.prevent="show = false"
                />
            </v-card-title>

            <v-card-text class="px-6 py-5">
                <div v-if="canGenerateInventory" class="mb-6">
                    <p class="text-subtitle-2 text-medium-emphasis mb-3">
                        Créer ou mettre à jour le document
                    </p>
                    <DocumentsDownloadLink
                        :url="epciCommuneInput.inventory"
                        :filename="`${epciCommuneInput.v}.pdf`"
                    >
                        <template #default="{ loading }">
                            <div ref="downloadWrapper">
                                <v-btn
                                    color="primary"
                                    variant="flat"
                                    block
                                    prepend-icon="mdi-application-edit-outline"
                                    :loading="loading"
                                    @click.stop="isActive = true"
                                >
                                    Générer un nouvel inventaire
                                </v-btn>
                            </div>
                        </template>
                    </DocumentsDownloadLink>
                </div>

                <v-divider v-if="canGenerateInventory" class="mb-6" />

                <div v-if="epciCommuneInput.download">
                    <p class="text-subtitle-2 text-medium-emphasis mb-3 d-flex flex-column">
                        <span>Consulter la version actuelle</span>
                        <!--                        <span v-if="formattedLastDate" class="text-caption text-grey mt-1">
                                                    Dernière mise à jour : {{ formattedLastDate }}
                                                </span> -->
                    </p>

                    <DocumentsDownloadLink :url="epciCommuneInput.download" :filename="`${epciCommuneInput.v}.pdf`">
                        <template #default="{ loading }">
                            <v-btn
                                color="secondary"
                                variant="flat"
                                :loading="loading"
                                block
                                prepend-icon="mdi-download"
                            >
                                Télécharger l'inventaire
                            </v-btn>
                        </template>
                    </DocumentsDownloadLink>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="isActive" max-width="450">
        <v-card>
            <v-card-title class="border-b px-6 py-4">
                Générer un nouvel inventaire
            </v-card-title>
            <v-card-text class="px-6 py-4">
                <p class="mb-4">
                    Êtes-vous sûr de vouloir générer un nouvel inventaire ? Cette action écrasera la version actuelle et peut prendre quelques instants.
                </p>
                <div class="d-flex align-center mt-4">
                    <v-btn
                        text="Annuler"
                        variant="text"
                        @click="isActive = false"
                    />
                    <v-spacer />

                    <v-btn
                        color="primary"
                        @click="confirmGeneration"
                    >
                        Confirmer
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
